import React from 'react';
import Numerisation from './Numerisation';

const AdminNumerisation: React.FC = () => {
  return <Numerisation />;
};

export default AdminNumerisation;
